import { render, staticRenderFns } from "./BoardListItem.vue?vue&type=template&id=80b244bc&"
import script from "./BoardListItem.vue?vue&type=script&lang=js&"
export * from "./BoardListItem.vue?vue&type=script&lang=js&"
import style0 from "./BoardListItem.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports